import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=66136430&scoped=true"
import script from "./NotificationDialog.vue?vue&type=script&lang=js"
export * from "./NotificationDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationDialog.vue?vue&type=style&index=0&id=66136430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66136430",
  null
  
)

export default component.exports